import { DEFAULT_STYLE_FILE_NAME } from './default-style-file-name'

/**
 *
 *
 *
 */
export function getStyleFile(
  onexConfig: {
    styleFile: string | undefined
  } | null
) {
  return onexConfig?.styleFile ?? DEFAULT_STYLE_FILE_NAME
}
